import styled from 'styled-components'

import * as PT from 'modules/Pricing/types'

import * as E from 'types/enums'

interface IGridItemContainerProps extends Partial<PT.IPricingPackageCardModeProps> {
  rowStart?: number
  rowEnd?: number
  columnStart?: number
  columnEnd?: number
  backgroundColor?: string
  hideOnMobile?: boolean
  desktopBorderRadius?: string
  desktopPadding?: string
  zIndex?: number
  packageType?: E.PackageType
}

const getPadding = (props: IGridItemContainerProps) => {
  if (props.packageType === E.PackageType.basic) return 'padding: 0 28px 0 32px'

  if (props.packageType === E.PackageType.elite) return 'padding: 0 32px 0 28px'

  if (props.mode === E.PackageCardMode.Best) return ''

  return 'padding: 0 28px'
}

const GridItemContainer = styled.div<
  IGridItemContainerProps & Partial<PT.IPricingPackageCardModeProps>
>`
  display: ${props => (props.hideOnMobile ? 'none' : 'block')};
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    display: block;
    z-index: ${props => (props.mode === E.PackageCardMode.Best ? 1 : 0)};
    ${props => props.zIndex && `z-index: ${props.zIndex}`};
    ${props => props.desktopBorderRadius && `border-radius: ${props.desktopBorderRadius}`};
    ${props => props.backgroundColor && `background-color: ${props.backgroundColor}`};
    ${props => props.rowStart && `grid-row-start: ${props.rowStart}`};
    ${props => props.rowEnd && `grid-row-end: ${props.rowEnd}`};
    ${props => props.columnStart && `grid-column-start: ${props.columnStart}`};
    ${props => props.columnStart && `grid-column-end: ${props.columnEnd}`};
    ${props => props.packageType && getPadding(props)};
    ${props => props.desktopPadding && `padding: ${props.desktopPadding}`};
  }
`
export default GridItemContainer
